import head_CN_Locale from "./head/zh-CN";
import swiper_CN_Locale from "./swiper/zh-CN";
import solution_CN_Locale from "./solution/zh-CN";
import dynamic_CN_Locale from "./dynamic/zh-CN";
import partners_CN_Locale from "./partners/zh-CN";
import industry_CN_Locale from "./industry/zh-CN";
import productList_CN_Locale from "./productList/zh-CN";
import property_CN_Locale from "./property/zh-CN";
import about_CN_Locale from "./about/zh-CN";
import step_CN_Locale from "./step/zh-CN";
import map_CN_Locale from "./map/zh-CN";
import solve_CN_Locale from "./solve/zh-CN";
import product_CN_Locale from "./product/zh-CN";
import productDetails_CN_Locale from "./productDetails/zh-CN";
import news_CN_Locale from "./news/zh-CN";

export default {
  ...head_CN_Locale,
  ...swiper_CN_Locale,
  ...solution_CN_Locale,
  ...dynamic_CN_Locale,
  ...partners_CN_Locale,
  ...industry_CN_Locale,
  ...productList_CN_Locale,
  ...property_CN_Locale,
  ...about_CN_Locale,
  ...step_CN_Locale,
  ...map_CN_Locale,
  ...solve_CN_Locale,
  ...product_CN_Locale,
  ...productDetails_CN_Locale,
  ...news_CN_Locale
};
